import { Input } from "@nextui-org/react";
import { twMerge } from "tailwind-merge";
import clsx from "clsx";
import { FieldValues, RegisterOptions, UseFormRegister } from "react-hook-form";

type VariantType = "flat" | "faded" | "bordered" | "underlined";

type FormData = FieldValues;

type InputFieldProps = {
  label?: string;
  placeholder?: string;
  variant?: VariantType;
  type: string;
  name: string;
  error?: any;
  register: UseFormRegister<any>;
  validate?: RegisterOptions<FormData>;
  description?: string;
  defaultValue?: any;
  disabled?: any;
};

const InputField = ({
  label,
  placeholder,
  variant = "faded",
  description,
  type,
  name,
  error,
  register,
  validate,
  defaultValue,
  disabled = false,
}: InputFieldProps) => {
  return (
    <div className="flex flex-col w-full gap-2">
      <Input
        size="sm"
        label={label}
        placeholder={placeholder}
        variant={variant}
        disabled={disabled}
        type={type}
        isInvalid={!!error}
        defaultValue={defaultValue}
        description={description}
        errorMessage={error?.message}
        {...register(name, validate)}
        className={twMerge(
          "min-w-full my-1",
          clsx({ "border-red-500": error }) // if error = true => border-red-500
        )}
      />
    </div>
  );
};

export default InputField;
